import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { formatEncodingExceptionqalxwmlsg11w as formatEncodingException } from './internal/JsonExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonDecodingExceptionClass;
function JsonDecodingException() {
  if (JsonDecodingExceptionClass === VOID) {
    class $ extends JsonException() {
      static c2q(fullMessage, shortMessage, offset, path, input, hint) {
        var $this = this.s2q(fullMessage);
        captureStack($this, $this.b2q_1);
        $this.w2p_1 = shortMessage;
        $this.x2p_1 = offset;
        $this.y2p_1 = path;
        $this.z2p_1 = input;
        $this.a2q_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDecodingException');
    JsonDecodingExceptionClass = $;
  }
  return JsonDecodingExceptionClass;
}
var JsonExceptionClass;
function JsonException() {
  if (JsonExceptionClass === VOID) {
    class $ extends SerializationException() {
      static s2q(message) {
        var $this = this.m1o(message);
        captureStack($this, $this.r2q_1);
        $this.q2q_1 = message;
        delete $this.message;
        return $this;
      }
      r() {
        return this.q2q_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'JsonException');
    JsonExceptionClass = $;
  }
  return JsonExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends JsonException() {
      static d2r(shortMessage, classSerialName, hint) {
        classSerialName = classSerialName === VOID ? null : classSerialName;
        hint = hint === VOID ? null : hint;
        var $this = this.s2q(formatEncodingException(shortMessage, hint));
        captureStack($this, $this.c2r_1);
        $this.z2q_1 = shortMessage;
        $this.a2r_1 = classSerialName;
        $this.b2r_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
//region block: exports
export {
  JsonDecodingException as JsonDecodingExceptionoyag1psadwuw,
  JsonEncodingException as JsonEncodingException3vzv9k0f9l05u,
};
//endregion

//# sourceMappingURL=JsonExceptions.mjs.map
